import { registerViewMount } from './navigation.js';
import { appendTrustedAdminViewFragment } from './trusted-admin-view-fragment.js';

let systemHealthMountPromise = null;

export function initSystemHealthViewFragment({ onMounted } = {}) {
  registerViewMount('admin-system-health', () => mountSystemHealthView(onMounted));
}

async function mountSystemHealthView(onMounted) {
  if (document.getElementById('view-admin-system-health')) return;
  if (systemHealthMountPromise) return systemHealthMountPromise;

  systemHealthMountPromise = (async () => {
    const host = document.getElementById('admin-lazy-view-host');
    if (!host) throw new Error('Admin lazy view host is unavailable');

    await appendTrustedAdminViewFragment(host, '/admin-views/system-health.html', 'Unable to load system health view');
    onMounted?.();
  })();

  try {
    await systemHealthMountPromise;
  } catch (error) {
    systemHealthMountPromise = null;
    throw error;
  }
}
